<script lang="ts" setup>
withDefaults(
  defineProps<{
    adminLogoVariant?: 'dark' | 'light'
    width?: number | string
    height?: number | string
    fillColor?: string
    strokeColor?: string
  }>(),
  {
    width: 477,
    height: 122,
    fillColor: 'currentColor',
    strokeColor: 'currentColor',
  }
)
</script>

<template>
  <div
    class="skribble-logo"
    :class="{
      'skribble-business': Boolean(adminLogoVariant),
      'skribble-business-dark': adminLogoVariant === 'dark',
    }"
  >
    <nuxt-img src="/img/logo-skribble.svg" width="54" height="30" alt="Skribble" />
    <div class="skribble-logo-text">Skribble</div>
    <small v-if="adminLogoVariant">Admin</small>
  </div>
</template>

<style lang="scss" scoped>
.skribble-logo {
  display: flex;
  align-items: center;
  font: bold 1.875rem/1 $averta;
  color: $c-text-alt;
  @include maw(xs) {
    font-size: 1.5rem;
  }
  &:hover {
    color: $c-text-alt;
  }
  img {
    flex-shrink: 0;
    margin-right: 3px;
    height: auto;
    @include maw(xs) {
      width: 40px;
    }
  }
  small {
    margin-top: 5px;
    margin-left: 7px;
    font: normal 0.65rem/1 $averta;
    color: white;
  }
  &.skribble-business {
    @include maw(sm) {
      font-size: 1.2rem;
    }
    .skribble-logo-text {
      color: white;
      font-size: 29px;
      margin-right: 6px;
      letter-spacing: -0.7px;
      @include maw(sm) {
        font-size: 25px;
        letter-spacing: -0.6px;
      }
    }

    small {
      margin-top: 0;
      margin-left: 0;
      font: normal 18px/1.2 $averta;
      color: white;
      letter-spacing: -0.7px;
      height: 100%;
      display: flex;
      align-items: flex-end;
      @include maw(sm) {
        font-size: 16px;
        letter-spacing: -0.9px;
        line-height: 1.1;
      }
    }
    img {
      margin-right: 6px;
      width: 50px;
      height: auto;
      @include maw(sm) {
        width: 42px;
      }
    }
    &-dark {
      small {
        color: $c-grey-dark-2;
      }
      .skribble-logo-text {
        color: $c-text-alt;
      }
    }
  }
}
</style>
